var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"table2",staticClass:"info-container"},[_c('div',{staticClass:"info-header"},[_c('div',{staticClass:"info-header-title"},[_vm._v(_vm._s(_vm.showLang('com.data.real.time')))])]),_c('div',{staticClass:"info-body"},[_c('StationList',{attrs:{"tabHeight":_vm.tabHeight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }